import {
    setCustomValidator,
    ExtendedFieldId,
    ExtendedErrorId,
    Validator,
    FieldContent,
} from '@sheerid/jslib';

const DECIMAL_RADIX = 10;
const MIN_BIRTHYEAR = 1900;
const MAX_BIRTHYEAR = 3000;

const isValidDateFormat = (value: string): boolean => {
    const VALID_DATE_FORMAT_REGEXP = /^\d{4}[\-\s\/]\d{1,2}[\-\s\/]\d{1,2}$/;

    if (VALID_DATE_FORMAT_REGEXP.test(value)) {
        return true;
    }
    return false;
};

const isValidDate = (value: string): boolean => {
    const dateParts = value.split('-');
    const dateYear = parseInt(dateParts[0], DECIMAL_RADIX);
    const dateMonth = parseInt(dateParts[1], DECIMAL_RADIX);
    const dateDay = parseInt(dateParts[2], DECIMAL_RADIX);
    const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (dateYear < MIN_BIRTHYEAR || dateYear > MAX_BIRTHYEAR || dateMonth <= 0 || dateMonth > 12) {
        return false;
    }

    // Check for leap years
    if (dateYear % 400 === 0 || (dateYear % 100 !== 0 && dateYear % 4 === 0)) {
        monthDays[1] = 29;
    }

    if (dateDay <= 0 || dateDay > monthDays[dateMonth - 1]) {
        return false;
    }
    return true;
};

export const babyDueDateValidator = () => {
    const babyDueDate: ExtendedFieldId = 'babyDueDate';

    const getBabyDueDateValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidBabyDueDate';

        // Ensure that the value is in a valid date format, if a value is optinally provided
        if (value && (!isValidDateFormat(value as string) || !isValidDate(value as string))) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(babyDueDate, getBabyDueDateValidationError);
};

export const returnToWorkValidator = () => {
    const returnToWork: ExtendedFieldId = 'returnToWork';

    const getReturnToWorkValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidReturnToWorkDate';

        // Ensure that the value is in a valid date format, if a value is optinally provided
        if (value && (!isValidDateFormat(value as string) || !isValidDate(value as string))) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(returnToWork, getReturnToWorkValidationError);
};
